import React, { Component } from 'react';
import App from '../App';
import { GameModes } from '../models/GameModes';
import { GameState } from '../models/GameState';
import { UserTypes } from '../models/UserTypes';

interface IState {
	gameState: GameState;
	inputGameId: string;
	inputName: string;
}

interface IProps {
	app: App;
	connection: signalR.HubConnection;
}

class PlayerPanel extends Component<IProps, IState> {
	
	private connection: signalR.HubConnection;
	private readonly USER_STORAGE_KEY = 'UserNameCache';

	constructor(props: IProps) {
		super(props);

		this.connection = props.connection;

		this.state = {
			inputGameId: '',
			inputName: localStorage.getItem(this.USER_STORAGE_KEY) || '',
			gameState: {
				id: '',
				mode: GameModes.None,
				players: []
			}
		};
	}

	async componentDidMount() {
		this.connection.on("gameStateChanged", this.onGameStateChanged);
		const inputGameId = await this.connection.invoke<string>("findLocalGame");
		if (inputGameId) {
			this.setState({ inputGameId });
		}
	}

	onGameStateChanged = (gameState: GameState) => {
		this.setState({ gameState });
	}

	joinGame() {
		const { inputGameId, inputName } = this.state;

		// save name for next games in local storage
		localStorage.setItem(this.USER_STORAGE_KEY, inputName);

		// join the game
		this.connection.send("joinGame", inputGameId, inputName);
	}

	back() {
		this.props.app.setState({
			type: UserTypes.None
		});
	}

	respond(answer: string) {
		this.connection.send("respond", answer);

		const { gameState } = this.state;
		gameState.mode = GameModes.None;
		this.setState({ gameState });
	}

	renderContent() {
		const { gameState } = this.state;

		switch (gameState.mode) {
			case GameModes.None:
				return (
					<p>Waiting for admin action...</p>
				);
			case GameModes.FirstToPress:
				return (
					<div>
						<a className="nice-button" onClick={() => this.respond("Answer")}>Answer</a>
					</div>
				);
			case GameModes.FourForEach:
				return (
					<div>
						<div>
							<a className="nice-button" onClick={() => this.respond("A")}>A</a>
							<a className="nice-button" onClick={() => this.respond("B")}>B</a>
						</div>
						<div>
							<a className="nice-button" onClick={() => this.respond("C")}>C</a>
							<a className="nice-button" onClick={() => this.respond("D")}>D</a>
						</div>
					</div>
				);
		}

		return "";
	}

	renderLoginForm() {
		const { inputGameId, inputName } = this.state;

		return (
			<div>
				<h3>Please enter the folowing items to join a game:</h3>
				<h3>Your short name:</h3>
				<div><input type="text" className="nice-input" value={inputName} onChange={(e) => this.setState({ inputName: e.target.value })} /></div>
				<h3>Game ID:</h3>
				<div><input type="text" className="nice-input" value={inputGameId} onChange={(e) => this.setState({ inputGameId: e.target.value })} /></div>
				<p>
					<a className="nice-button" onClick={() => this.joinGame()}>Join game</a>&nbsp;
					<a className="nice-button" onClick={() => this.back()}>Back</a>
				</p>
			</div>
		);
	}
	
	render() {
		const { gameState } = this.state;

		return (
			<div className="player-panel">
				{
					gameState.id != ''
					? (
						<div>
							<h3>Game { gameState.id }</h3>
							{ this.renderContent() }
						</div>
					)
					: this.renderLoginForm()
				}
			</div>
		);
	}
}

export default PlayerPanel;
